import "./service.css"
import Card from 'react-bootstrap/Card';
import Button from 'react-bootstrap/Button';
import { Link } from "react-router-dom";



function Service(){
  const gettop=()=>{
    window.scrollTo({
      top:0,
      behavior:"smooth"
    })
  }
    return(
        <>
        <div className="service">
           <div className="container">
  <h4>Our Medical Services</h4>
  <p>
    We offer a comprehensive range of medical services with the highest quality standards.
  </p>
</div>
<div className="content">
  <div className="row g-4">

  {/* 1 */}
  <div className="col-md-4">
    <Card className=" h-100 p-3">
      <Card.Body>
        <i className="fa-solid fa-heart-pulse fa-2x mb-3"></i>
        <Card.Title>Chronic Disease Clinic</Card.Title>
        <Card.Text>
          Specialized in monitoring chronic conditions such as diabetes,
          hypertension, heart and respiratory diseases. The clinic provides
          regular checkups, personalized treatment plans, and continuous
          medical guidance to help patients .
        </Card.Text>
<Card.Link href="#">
  <Link to="/oneservices" className="nav-link">                   <Button  onClick={gettop} variant="danger">Book Appointments</Button>
</Link>


        </Card.Link>      </Card.Body>
    </Card>
  </div>

  {/* 2 */}
  <div className="col-md-4">
    <Card className=" h-100 p-3">
      <Card.Body>
        <i className="fa-solid fa-user-doctor fa-2x mb-3"></i>
        <Card.Title>Family Medicine Clinic</Card.Title>
        <Card.Text>
          Provides comprehensive healthcare for all family members including
          children and adults. Services include routine examinations,
          preventive care, vaccinations, and long-term health monitoring in all the world section above the clinical.
        </Card.Text>
<Card.Link href="#">
 <Link to="/twoservices" className="nav-link">                   <Button  onClick={gettop} variant="danger">Book Appointments</Button>
</Link>
        </Card.Link>      </Card.Body>
    </Card>
  </div>

  {/* 3 */}
  <div className="col-md-4">
    <Card className=" h-100 p-3">
      <Card.Body>
        <i className="fa-solid fa-dumbbell fa-2x mb-3"></i>
        <Card.Title>Physical Therapy</Card.Title>
        <Card.Text>
          Offers rehabilitation programs designed to restore mobility and
          strength after injuries or surgeries. Our specialists use modern
          techniques and customized exercises to reduce pain and improve recovery in all the world section above the clinical.
        </Card.Text>
<Card.Link href="#">
 <Link to="/threeservices" className="nav-link">                   <Button  onClick={gettop} variant="danger">Book Appointments</Button>
</Link>
        </Card.Link>      </Card.Body>
    </Card>
  </div>

  {/* 4 */}
  <div className="col-md-4">
    <Card className=" h-100 p-3">
      <Card.Body>
        <i className="fa-solid fa-stethoscope fa-2x mb-3"></i>
        <Card.Title>General Checkup</Card.Title>
        <Card.Text>
          Provides full health examinations to detect potential health
          problems early. Services include blood pressure checks,
          health assessments, and medical advice for maintaining wellness.
        </Card.Text>
<Card.Link href="#">
 <Link to="/fourservices" className="nav-link">                   <Button  onClick={gettop} variant="danger">Book Appointments</Button>
</Link>
        </Card.Link>      </Card.Body>
    </Card>
  </div>

  {/* 5 */}
  <div className="col-md-4">
    <Card className=" h-100 p-3">
      <Card.Body>
        <i className="fa-solid fa-baby fa-2x mb-3"></i>
        <Card.Title>Pediatric Clinic</Card.Title>
        <Card.Text>
          Dedicated to providing healthcare for infants and children.
          The clinic offers routine checkups, vaccination programs,
          and treatment for common childhood illnesses.
        </Card.Text>
<Card.Link href="#">
 <Link to="/fiveservices" className="nav-link">                   <Button  onClick={gettop} variant="danger">Book Appointments</Button>
</Link>
        </Card.Link>      </Card.Body>
    </Card>
  </div>

  {/* 6 */}
  <div className="col-md-4">
    <Card className=" h-100 p-3">
      <Card.Body>
        <i className="fa-solid fa-flask fa-2x mb-3"></i>
        <Card.Title>Medical Laboratory</Card.Title>
        <Card.Text>
          Provides accurate laboratory testing including blood tests,
          diagnostic screenings, and medical analysis to support
          doctors in making precise diagnoses and treatment plans.
        </Card.Text>
        <Card.Link href="#">
 <Link to="/sixservices" className="nav-link">                   <Button  onClick={gettop} variant="danger">Book Appointments</Button>
</Link>
        </Card.Link>
      </Card.Body>
    </Card>
  </div>

</div>
<div className="row m-3">
   <Link  to="/Services" className="nav-link">             <Button onClick={gettop} className="w-100" variant="danger">Show All Services</Button>

</Link>

</div>
</div>
        </div>
        </>
    )
}
export default  Service